// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function channel_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var consent_config_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "consent_config_id"), null));
  if (consent_config_id.TAG === /* Ok */0) {
    var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var enabled = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "enabled"), null));
      if (enabled.TAG === /* Ok */0) {
        var alterable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alterable"), null));
        if (alterable.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    consent_config_id: consent_config_id._0,
                    title: title._0,
                    enabled: enabled._0,
                    alterable: alterable._0
                  }
                };
        }
        var e = alterable._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".alterable" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = enabled._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".enabled" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = consent_config_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".consent_config_id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function consent_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var message_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message_type"), null));
  if (message_type.TAG === /* Ok */0) {
    var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
      if (message.TAG === /* Ok */0) {
        var channels = Decco.arrayFromJson(channel_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "channels"), null));
        if (channels.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    message_type: message_type._0,
                    title: title._0,
                    message: message._0,
                    channels: channels._0
                  }
                };
        }
        var e = channels._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".channels" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = message._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".message" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = message_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".message_type" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var consents = Decco.arrayFromJson(consent_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "consents"), null));
  if (consents.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              consents: consents._0
            }
          };
  }
  var e = consents._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".consents" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  channel_decode ,
  consent_decode ,
  t_decode ,
  
}
/* No side effect */
